var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0432 11.9573V15.0589H23.999L23.3726 19.2371H20.0432V28.8633C19.3757 28.9531 18.6927 29 17.9995 29C17.1993 29 16.4135 28.9382 15.6482 28.8184V19.2371H12V15.0589H15.6482V11.2639C15.6482 8.90949 17.6158 7 20.0442 7V7.00199C20.0514 7.00199 20.0576 7 20.0648 7H24V10.6135H21.4286C20.6644 10.6135 20.0442 11.215 20.0442 11.9563L20.0432 11.9573Z",
    fill: "#100A55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.86e8fbc3ffe2623a83302d0028c07302.svg";
export { ForwardRef as ReactComponent };